import { memo } from "react";
import { Popup } from "components/popups/Popup";
import { Button } from "components/buttons/Button";
import { IAddDescriptionPopup } from "@/common/buses/popups/popup-types";
import { onCloseAddDescriptionPopup } from "@/components/popup-dispatcher/PopupDispatcher";
import "./AddDescriptionPopup.scss";

export const AddDescriptionPopup = memo((props: IAddDescriptionPopup) => {
  const onAddDescription = () => {
    onCloseAddDescriptionPopup();
    props.onAddDescription();
  };

  const onPublish = () => {
    onCloseAddDescriptionPopup();
    props.onPublish();
  };

  return (
    <Popup
      title="Confirmation"
      isOpen={true}
      popupClass="AddDescriptionPopup"
      onClose={onAddDescription}
    >
      <div className="AddDescriptionPopup-Cnt">
        <h2 className="AddDescriptionPopup-Title">No Description?</h2>
        <p className="AddDescriptionPopup-Text">
          Without a description, your content may have a harder time getting discovered by the RG community.
          Are you sure you want to continue without one?
        </p>
        <div className="AddDescriptionPopup-Bottom">
          <Button size={"l"} variant="secondary" onClick={onPublish}>Continue</Button>
          <Button size={"l"} variant="primary" onClick={onAddDescription}>Add Description</Button>
        </div>
      </div>
    </Popup>
  );
});
